import { Tooltip as MantineTooltip, type TooltipFactory } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./tooltip.module.scss";
import type { IProps } from "./tooltip.types";
import { TOOLTIP_DEFAULT_DELAY } from "./tooltip.constants";

const Tooltip = componentWrapper<TooltipFactory, IProps>("Tooltip", ({ delayOpen = false, ...props }, ref) => {
    return (
        <MantineTooltip
            p="md"
            bdrs="md"
            maw={540}
            multiline
            withArrow
            arrowSize={9}
            ref={ref}
            classNames={{ tooltip: styles["container"] }}
            openDelay={delayOpen ? TOOLTIP_DEFAULT_DELAY : 0}
            {...props}
        />
    );
});

Tooltip.Floating = MantineTooltip.Floating;
Tooltip.Group = MantineTooltip.Group;

export { Tooltip };
